import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';
import { ClientMailingsResponse, MailingChannel, MailingType } from '../types/mailing.types';

class MailingService {
  async getClientMailings(clientId: number | string): Promise<ClientMailingsResponse> {
    const response = await api.get<ApiResponse<ClientMailingsResponse>>(`/expert/clients/${clientId}/mailings`);
    const data = unwrapApiResponse<ClientMailingsResponse>(response);
    return {
      hasTelegramConnected: data.hasTelegramConnected ?? false,
      subscriptions: data.subscriptions ?? [],
    };
  }

  async subscribe(clientId: number | string, type: MailingType, channel: MailingChannel): Promise<void> {
    await api.post(`/expert/clients/${clientId}/mailings`, { type, channel });
  }

  async unsubscribe(clientId: number | string, type: MailingType, channel: MailingChannel): Promise<void> {
    await api.delete(`/expert/clients/${clientId}/mailings`, { data: { type, channel } });
  }
}

export const mailingService = new MailingService();
